module.exports = __webpack_public_path__ + "static/media/Exhibition-4@2x.4c646ad6.png";